import React, { useEffect } from 'react';

const ExportPDF = ({ 
    contentId, 
    orientation = "portrait",   // 'portrait' | 'landscape'
 }) => {
    const handleDownload = () => {
        const element = document.getElementById(contentId); // 전체 페이지 콘텐츠를 가져옴
        if (element) {
            if (window.html2pdf) {
                // html2pdf.js 설정
                const options = {
                    margin:       0, // 여백을 최소화
                    filename:     'report.pdf', // 파일 이름
                    image:        { type: 'jpeg', quality: 0.98 },
                    html2canvas:  { dpi: 300, letterRendering: true, useCORS: true, scale: 3 },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4', // A4
                        orientation: orientation  // 가로 세로 선택
                    }
                };

                window.html2pdf(element, options);
            }
        } else {
            console.error("변환할 콘텐츠가 없습니다.");
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.2/html2pdf.bundle.js';
        script.async = true;
        script.onload = () => {
            console.log('html2pdf.js가 성공적으로 로드되었습니다.');
        };
        script.onerror = () => {
            console.error('html2pdf.js 로드에 실패했습니다.');
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <button onClick={handleDownload} className="btn-basic">
            PDF로 다운로드
        </button>
    );
};

export default ExportPDF;
